export const hasPermission = (allowedRoles: any, userRoles: any): boolean => {
  const allowed = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
  const user = Array.isArray(userRoles) ? userRoles : [userRoles];

  if (!allowed.length || !user.length) return false;

  const containsDefault = (r: any) => {
    if (typeof r === "string") return r.toLowerCase().includes("default");
    if (typeof r === "object") {
      const n = (r.Name ?? r.name ?? "").toString().toLowerCase();
      return n.includes("default");
    }
    return false;
  };
  if (allowed.some(containsDefault)) return true;

  // 2) Otherwise do normal matching (by id or name)
  const toKeySet = (arr: any[]) => {
    const keys = new Set<string>();
    for (const r of arr) {
      if (r == null) continue;
      if (typeof r === "number") keys.add(`id:${r}`);
      else if (typeof r === "string")
        keys.add(`name:${r.trim().toLowerCase()}`);
      else if (typeof r === "object") {
        if (r.Id != null) keys.add(`id:${Number(r.Id)}`);
        if (r.id != null) keys.add(`id:${Number(r.id)}`);
        const nm = (r.Name ?? r.name)?.toString().trim().toLowerCase();
        if (nm) keys.add(`name:${nm}`);
      }
    }
    return keys;
  };

  const allowedSet = toKeySet(allowed);
  const userSet = toKeySet(user);
  for (const k of userSet) if (allowedSet.has(k)) return true;
  return false;
};
